import React, { useEffect, useState } from 'react';
import Select from 'react-select';
import classes from './OrganizationSelect.module.scss';

function OrganizationSelect({ organizations, onChangeHandler }) {
  const [orgsOptions, setOrgsOptions] = useState('all');

  useEffect(() => {
    setOrgsOptions(organizations);
  }, [organizations]);


  return (
    <div className={classes.organizationsContainer}>
      <p>Organization:</p>
      <Select
        options={[
          { value: 'all', label: 'All organizations' },
          { value: 'none', label: 'Not assigned' },
          ...orgsOptions,
        ]}
        onChange={onChangeHandler}
        placeholder="All organizations"
      />
    </div>
  );
}

export default OrganizationSelect;
